import { Card, Descriptions } from 'antd';
import { useTranslation } from 'react-i18next';
import { type SdmModuleSpecsFragment, type AudiFinancingModuleSpecsFragment } from '../../../../../api/fragments';

export type SalesForceProps = {
    module: SdmModuleSpecsFragment | AudiFinancingModuleSpecsFragment;
};

const SalesForce = ({ module }: SalesForceProps) => {
    const { t } = useTranslation(['sdmModuleDetails']);

    return (
        <Card>
            <Descriptions column={{ xs: 1, md: 2 }} bordered>
                <Descriptions.Item label={t('sdmModuleDetails:fields.salesForce.baseUrl.label')}>
                    {module.salesForceSetting.baseUrl}
                </Descriptions.Item>
                <Descriptions.Item label={t('sdmModuleDetails:fields.salesForce.clientId.label')}>
                    {module.salesForceSetting.clientId}
                </Descriptions.Item>
                <Descriptions.Item label={t('sdmModuleDetails:fields.salesForce.grantType.label')}>
                    {module.salesForceSetting.grantType}
                </Descriptions.Item>
            </Descriptions>
        </Card>
    );
};

export default SalesForce;
